import { render, staticRenderFns } from "./KSRServiceCheckout.vue?vue&type=template&id=1bc2184e&"
import script from "./KSRServiceCheckout.vue?vue&type=script&lang=js&"
export * from "./KSRServiceCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports